import React, {  useRef } from 'react'
import GooglePlacesLookup from './GooglePlacesLookup'

export default function PlacesSearchBox(props) {
    const [searchbox, setSearchbox] = React.useState(null);
    const [marker, setMarker] = React.useState(null);
    const inputRef = useRef(null);
    const map = props.map;

    const onPlacesChanged = () => {
        var mySearchBox = searchbox;
        console.log(mySearchBox.getPlaces());
        var places = searchbox.getPlaces();
        if (!places || places.length < 1) {
            return;
        }
        var place = places[0];
        var latlng = new window.google.maps.LatLng(
            place.geometry.location.lat(),
            place.geometry.location.lng());
        map.panTo(latlng);
        map.setZoom(15);
        setMarker(new window.google.maps.Marker({
            position: latlng,
            map: map,
            draggable: false
        }));
    }

    React.useEffect(() => {
        if (marker) {
            setTimeout(() => {
                marker.setMap(null);
                inputRef.current.value = "";
            }, 6000)
        }
    }, [marker, inputRef])

    return (
        <GooglePlacesLookup {...props} onPlacesChanged={onPlacesChanged} setSearchbox={setSearchbox} inputRef={inputRef}/>
    )

}